export const OrderUploadStatus = [
  { label: '全部', value: null, type: null },
  { label: '执行中', value: 0, type: null },
  { label: '全部失败', value: -1, type: 'danger' },
  { label: '全部成功', value: 1, type: 'success' },
  { label: '部分成功', value: 2, type: 'warning' },
  // { label: '待审核', value: 5, type: 'warning' },
  // { label: '审核不通过', value: 9, type: 'danger' },
  { label: '已取消', value: 10, type: 'danger' }
]

export const OrderUploadStatus1 = [
  { label: '全部', value: null, type: null },
  { label: '执行中', value: 0, type: null },
  { label: '全部失败', value: -1, type: 'danger' },
  { label: '全部成功', value: 1, type: 'success' },
  { label: '部分成功', value: 2, type: 'warning' },
  { label: '待审核', value: 5, type: 'warning' },
  { label: '审核通过', value: 7, type: 'success' },
  { label: '审核不通过', value: 9, type: 'danger' },
  { label: '已取消', value: 10, type: 'danger' }
]

export const locationMap = {
  'zl.cciczhejiang.com': '中检质量服务平台',
  'zjfw.ciqca.com': '中检产业链质量服务平台',
  'zzfw.ciqca.com': '中检质量服务平台',
  'cciczj.clousev.cn': '中检质量服务平台',
  'zzjd.ciqca.com': '奢侈品鉴定管理平台',
  'ccicjd.clousev.cn': '奢侈品鉴定管理平台',
  'localhost': '奢侈品鉴定管理平台'
}
